import React, { Component } from "react";
import CreateBanner from "./create_banner";
import ManageAppVideos from "./manage_videos";

const SECTIONS = [
    { key: "banners", label: "App Banners", icon: "campaign" },
    { key: "videos",  label: "App Videos",  icon: "play_circle" },
];

class Marketing extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: "banners" };
    }

    render() {
        const { selected } = this.state;

        return (
            <>
                {/* ── Section chips ── */}
                <div style={{ display: "flex", gap: 8, marginBottom: 24, flexWrap: "wrap" }}>
                    {SECTIONS.map(sec => {
                        const active = selected === sec.key;
                        return (
                            <button
                                key={sec.key}
                                type="button"
                                onClick={() => this.setState({ selected: sec.key })}
                                style={{
                                    display: "inline-flex", alignItems: "center", gap: 6,
                                    padding: "7px 18px", borderRadius: 20, cursor: "pointer",
                                    fontSize: 13, fontWeight: 600,
                                    border: active ? "none" : "1.5px solid #dee2e6",
                                    background: active ? "#f1061c" : "#fff",
                                    color: active ? "#fff" : "#555",
                                    boxShadow: active ? "0 2px 8px rgba(241,6,28,0.18)" : "none",
                                    transition: "all 0.15s",
                                }}
                            >
                                <i className="material-icons" style={{ fontSize: 16 }}>{sec.icon}</i>
                                {sec.label}
                            </button>
                        );
                    })}
                </div>

                {/* ── Mounted component ── */}
                {selected === "banners" && <CreateBanner />}
                {selected === "videos"  && <ManageAppVideos />}
            </>
        );
    }
}

export default Marketing;
